import { Address } from 'depoto-core/src/entities'

type PrepareOrderAddressForSaveOptions = {
  storeOnCustomer?: boolean
}

export function copyAddressForOrder(address: Address | Partial<Address>, isBilling: boolean): Address {
  return new Address({
    ...address,
    id: null,
    isBilling,
    isStored: false,
  })
}

export function prepareOrderAddressForSave(
  address: Address | Partial<Address>,
  isBilling: boolean,
  options: PrepareOrderAddressForSaveOptions = {}
): Address {
  const storeOnCustomer = options.storeOnCustomer === true
  const shouldKeepId = !storeOnCustomer && address?.isStored === false

  return new Address({
    ...address,
    id: shouldKeepId ? address.id : null,
    isBilling,
    isStored: storeOnCustomer,
  })
}
